export const SET_CHECKOUT = "SET_CHECKOUT";

export const APPEND_TO_CHECKOUT = "APPEND_TO_CHECKOUT";
